/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Detail_Page_Content_CnaInputs */

const en_subscription_detail_page_content_cna = /** @type {(inputs: Subscription_Detail_Page_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<div>

# Plus Tree Collection

- Unlimited access to Plus Exclusive Trees, Seasonal New Trees, and Seasonal Select Crystal Trees during your Plus membership. (not permanently unlocked)
- Plus Exclusive Trees are strictly reserved for Plus members.
- Seasonal content updates every Dec 31, Mar 31, Jun 30, and Sep 30 (UTC+8), including Seasonal New Trees, and Seasonal Select Crystal Trees.
- All trees can be used in "Plant together."


</div>

<div>

# Plus Advanced Features

|  | Free | Pro | Plus |
| --- | --- | --- | --- |
| Focus Timer | ✔️ | ✔️ | ✔️ |
| Duration Statistics | ✔️ | ✔️ | ✔️ |
| Plant together  | ✔️ | ✔️ | ✔️ |
| Deep Focus Mode | ✔️ | ✔️ | ✔️ |
| Custom App Allow List | - | ✔️ | ✔️ |
| Remove Ads | - | ✔️ | ✔️ |
| Focus trend analysis | - | ✔️ | ✔️ |
| Plant real trees* | - | ✔️ | ✔️ |
| Custom Focus Tags | - | ✔️ | ✔️ |
| Auto-start Next Session | - | ✔️ | ✔️ |
| 3x focus coin | - | - | ✔️ |
| Grow Plus Exclusive Trees | - | - | ✔️ |
| Try Seasonal New Trees First | - | - | ✔️ |
| Enjoy Seasonal Select Crystal Trees | - | - | ✔️ |
| [Time Guard] Block more interruptive apps | - | - | ✔️ |
| [Mindful Space] Enjoy various Soundscapes | - | - | ✔️ |

* *The maximum limit for planting real trees is 5.

- Pro users include iOS users who have paid to download Forest from the App Store, as well as Android users who have unlocked the Pro version. 
- For Pro users, all Pro features and benefits that were originally unlocked will be retained for life, regardless of purchasing Plus membership.

</div>`)
};

const ar_subscription_detail_page_content_cna = /** @type {(inputs: Subscription_Detail_Page_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<div>

# Plus Tree Collection

- Unlimited access to Plus Exclusive Trees, Seasonal New Trees, and Seasonal Select Crystal Trees during your Plus membership. (not permanently unlocked)
- Plus Exclusive Trees are strictly reserved for Plus members.
- Seasonal content updates every Dec 31, Mar 31, Jun 30, and Sep 30 (UTC+8), including Seasonal New Trees, and Seasonal Select Crystal Trees.
- All trees can be used in "Plant together."


</div>

<div>

# Plus Advanced Features

|  | Free | Pro | Plus |
| --- | --- | --- | --- |
| Focus Timer | ✔️ | ✔️ | ✔️ |
| Duration Statistics | ✔️ | ✔️ | ✔️ |
| Plant together  | ✔️ | ✔️ | ✔️ |
| Deep Focus Mode | ✔️ | ✔️ | ✔️ |
| Custom App Allow List | - | ✔️ | ✔️ |
| Remove Ads | - | ✔️ | ✔️ |
| Focus trend analysis | - | ✔️ | ✔️ |
| Plant real trees* | - | ✔️ | ✔️ |
| Custom Focus Tags | - | ✔️ | ✔️ |
| Auto-start Next Session | - | ✔️ | ✔️ |
| 3x focus coin | - | - | ✔️ |
| Grow Plus Exclusive Trees | - | - | ✔️ |
| Try Seasonal New Trees First | - | - | ✔️ |
| Enjoy Seasonal Select Crystal Trees | - | - | ✔️ |
| [Time Guard] Block more interruptive apps | - | - | ✔️ |
| [Mindful Space] Enjoy various Soundscapes | - | - | ✔️ |

* *The maximum limit for planting real trees is 5.

- Pro users include iOS users who have paid to download Forest from the App Store, as well as Android users who have unlocked the Pro version. 
- For Pro users, all Pro features and benefits that were originally unlocked will be retained for life, regardless of purchasing Plus membership.

</div>`)
};

const de_subscription_detail_page_content_cna = /** @type {(inputs: Subscription_Detail_Page_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<div>

# Plus Tree Collection

- Unlimited access to Plus Exclusive Trees, Seasonal New Trees, and Seasonal Select Crystal Trees during your Plus membership. (not permanently unlocked)
- Plus Exclusive Trees are strictly reserved for Plus members.
- Seasonal content updates every Dec 31, Mar 31, Jun 30, and Sep 30 (UTC+8), including Seasonal New Trees, and Seasonal Select Crystal Trees.
- All trees can be used in "Plant together."


</div>

<div>

# Plus Advanced Features

|  | Free | Pro | Plus |
| --- | --- | --- | --- |
| Focus Timer | ✔️ | ✔️ | ✔️ |
| Duration Statistics | ✔️ | ✔️ | ✔️ |
| Plant together  | ✔️ | ✔️ | ✔️ |
| Deep Focus Mode | ✔️ | ✔️ | ✔️ |
| Custom App Allow List | - | ✔️ | ✔️ |
| Remove Ads | - | ✔️ | ✔️ |
| Focus trend analysis | - | ✔️ | ✔️ |
| Plant real trees* | - | ✔️ | ✔️ |
| Custom Focus Tags | - | ✔️ | ✔️ |
| Auto-start Next Session | - | ✔️ | ✔️ |
| 3x focus coin | - | - | ✔️ |
| Grow Plus Exclusive Trees | - | - | ✔️ |
| Try Seasonal New Trees First | - | - | ✔️ |
| Enjoy Seasonal Select Crystal Trees | - | - | ✔️ |
| [Time Guard] Block more interruptive apps | - | - | ✔️ |
| [Mindful Space] Enjoy various Soundscapes | - | - | ✔️ |

* *The maximum limit for planting real trees is 5.

- Pro users include iOS users who have paid to download Forest from the App Store, as well as Android users who have unlocked the Pro version. 
- For Pro users, all Pro features and benefits that were originally unlocked will be retained for life, regardless of purchasing Plus membership.

</div>`)
};

const es_subscription_detail_page_content_cna = /** @type {(inputs: Subscription_Detail_Page_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<div>

# Plus Tree Collection

- Unlimited access to Plus Exclusive Trees, Seasonal New Trees, and Seasonal Select Crystal Trees during your Plus membership. (not permanently unlocked)
- Plus Exclusive Trees are strictly reserved for Plus members.
- Seasonal content updates every Dec 31, Mar 31, Jun 30, and Sep 30 (UTC+8), including Seasonal New Trees, and Seasonal Select Crystal Trees.
- All trees can be used in "Plant together."


</div>

<div>

# Plus Advanced Features

|  | Free | Pro | Plus |
| --- | --- | --- | --- |
| Focus Timer | ✔️ | ✔️ | ✔️ |
| Duration Statistics | ✔️ | ✔️ | ✔️ |
| Plant together  | ✔️ | ✔️ | ✔️ |
| Deep Focus Mode | ✔️ | ✔️ | ✔️ |
| Custom App Allow List | - | ✔️ | ✔️ |
| Remove Ads | - | ✔️ | ✔️ |
| Focus trend analysis | - | ✔️ | ✔️ |
| Plant real trees* | - | ✔️ | ✔️ |
| Custom Focus Tags | - | ✔️ | ✔️ |
| Auto-start Next Session | - | ✔️ | ✔️ |
| 3x focus coin | - | - | ✔️ |
| Grow Plus Exclusive Trees | - | - | ✔️ |
| Try Seasonal New Trees First | - | - | ✔️ |
| Enjoy Seasonal Select Crystal Trees | - | - | ✔️ |
| [Time Guard] Block more interruptive apps | - | - | ✔️ |
| [Mindful Space] Enjoy various Soundscapes | - | - | ✔️ |

* *The maximum limit for planting real trees is 5.

- Pro users include iOS users who have paid to download Forest from the App Store, as well as Android users who have unlocked the Pro version. 
- For Pro users, all Pro features and benefits that were originally unlocked will be retained for life, regardless of purchasing Plus membership.

</div>`)
};

const fr_subscription_detail_page_content_cna = /** @type {(inputs: Subscription_Detail_Page_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<div>

# Plus Tree Collection

- Unlimited access to Plus Exclusive Trees, Seasonal New Trees, and Seasonal Select Crystal Trees during your Plus membership. (not permanently unlocked)
- Plus Exclusive Trees are strictly reserved for Plus members.
- Seasonal content updates every Dec 31, Mar 31, Jun 30, and Sep 30 (UTC+8), including Seasonal New Trees, and Seasonal Select Crystal Trees.
- All trees can be used in "Plant together."


</div>

<div>

# Plus Advanced Features

|  | Free | Pro | Plus |
| --- | --- | --- | --- |
| Focus Timer | ✔️ | ✔️ | ✔️ |
| Duration Statistics | ✔️ | ✔️ | ✔️ |
| Plant together  | ✔️ | ✔️ | ✔️ |
| Deep Focus Mode | ✔️ | ✔️ | ✔️ |
| Custom App Allow List | - | ✔️ | ✔️ |
| Remove Ads | - | ✔️ | ✔️ |
| Focus trend analysis | - | ✔️ | ✔️ |
| Plant real trees* | - | ✔️ | ✔️ |
| Custom Focus Tags | - | ✔️ | ✔️ |
| Auto-start Next Session | - | ✔️ | ✔️ |
| 3x focus coin | - | - | ✔️ |
| Grow Plus Exclusive Trees | - | - | ✔️ |
| Try Seasonal New Trees First | - | - | ✔️ |
| Enjoy Seasonal Select Crystal Trees | - | - | ✔️ |
| [Time Guard] Block more interruptive apps | - | - | ✔️ |
| [Mindful Space] Enjoy various Soundscapes | - | - | ✔️ |

* *The maximum limit for planting real trees is 5.

- Pro users include iOS users who have paid to download Forest from the App Store, as well as Android users who have unlocked the Pro version. 
- For Pro users, all Pro features and benefits that were originally unlocked will be retained for life, regardless of purchasing Plus membership.

</div>`)
};

const it_subscription_detail_page_content_cna = /** @type {(inputs: Subscription_Detail_Page_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<div>

# Plus Tree Collection

- Unlimited access to Plus Exclusive Trees, Seasonal New Trees, and Seasonal Select Crystal Trees during your Plus membership. (not permanently unlocked)
- Plus Exclusive Trees are strictly reserved for Plus members.
- Seasonal content updates every Dec 31, Mar 31, Jun 30, and Sep 30 (UTC+8), including Seasonal New Trees, and Seasonal Select Crystal Trees.
- All trees can be used in "Plant together."


</div>

<div>

# Plus Advanced Features

|  | Free | Pro | Plus |
| --- | --- | --- | --- |
| Focus Timer | ✔️ | ✔️ | ✔️ |
| Duration Statistics | ✔️ | ✔️ | ✔️ |
| Plant together  | ✔️ | ✔️ | ✔️ |
| Deep Focus Mode | ✔️ | ✔️ | ✔️ |
| Custom App Allow List | - | ✔️ | ✔️ |
| Remove Ads | - | ✔️ | ✔️ |
| Focus trend analysis | - | ✔️ | ✔️ |
| Plant real trees* | - | ✔️ | ✔️ |
| Custom Focus Tags | - | ✔️ | ✔️ |
| Auto-start Next Session | - | ✔️ | ✔️ |
| 3x focus coin | - | - | ✔️ |
| Grow Plus Exclusive Trees | - | - | ✔️ |
| Try Seasonal New Trees First | - | - | ✔️ |
| Enjoy Seasonal Select Crystal Trees | - | - | ✔️ |
| [Time Guard] Block more interruptive apps | - | - | ✔️ |
| [Mindful Space] Enjoy various Soundscapes | - | - | ✔️ |

* *The maximum limit for planting real trees is 5.

- Pro users include iOS users who have paid to download Forest from the App Store, as well as Android users who have unlocked the Pro version. 
- For Pro users, all Pro features and benefits that were originally unlocked will be retained for life, regardless of purchasing Plus membership.

</div>`)
};

const ja_subscription_detail_page_content_cna = /** @type {(inputs: Subscription_Detail_Page_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<div>

# Plus Tree Collection

- Unlimited access to Plus Exclusive Trees, Seasonal New Trees, and Seasonal Select Crystal Trees during your Plus membership. (not permanently unlocked)
- Plus Exclusive Trees are strictly reserved for Plus members.
- Seasonal content updates every Dec 31, Mar 31, Jun 30, and Sep 30 (UTC+8), including Seasonal New Trees, and Seasonal Select Crystal Trees.
- All trees can be used in "Plant together."


</div>

<div>

# Plus Advanced Features

|  | Free | Pro | Plus |
| --- | --- | --- | --- |
| Focus Timer | ✔️ | ✔️ | ✔️ |
| Duration Statistics | ✔️ | ✔️ | ✔️ |
| Plant together  | ✔️ | ✔️ | ✔️ |
| Deep Focus Mode | ✔️ | ✔️ | ✔️ |
| Custom App Allow List | - | ✔️ | ✔️ |
| Remove Ads | - | ✔️ | ✔️ |
| Focus trend analysis | - | ✔️ | ✔️ |
| Plant real trees* | - | ✔️ | ✔️ |
| Custom Focus Tags | - | ✔️ | ✔️ |
| Auto-start Next Session | - | ✔️ | ✔️ |
| 3x focus coin | - | - | ✔️ |
| Grow Plus Exclusive Trees | - | - | ✔️ |
| Try Seasonal New Trees First | - | - | ✔️ |
| Enjoy Seasonal Select Crystal Trees | - | - | ✔️ |
| [Time Guard] Block more interruptive apps | - | - | ✔️ |
| [Mindful Space] Enjoy various Soundscapes | - | - | ✔️ |

* *The maximum limit for planting real trees is 5.

- Pro users include iOS users who have paid to download Forest from the App Store, as well as Android users who have unlocked the Pro version. 
- For Pro users, all Pro features and benefits that were originally unlocked will be retained for life, regardless of purchasing Plus membership.

</div>`)
};

const ko_subscription_detail_page_content_cna = /** @type {(inputs: Subscription_Detail_Page_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<div>

# Plus Tree Collection

- Unlimited access to Plus Exclusive Trees, Seasonal New Trees, and Seasonal Select Crystal Trees during your Plus membership. (not permanently unlocked)
- Plus Exclusive Trees are strictly reserved for Plus members.
- Seasonal content updates every Dec 31, Mar 31, Jun 30, and Sep 30 (UTC+8), including Seasonal New Trees, and Seasonal Select Crystal Trees.
- All trees can be used in "Plant together."


</div>

<div>

# Plus Advanced Features

|  | Free | Pro | Plus |
| --- | --- | --- | --- |
| Focus Timer | ✔️ | ✔️ | ✔️ |
| Duration Statistics | ✔️ | ✔️ | ✔️ |
| Plant together  | ✔️ | ✔️ | ✔️ |
| Deep Focus Mode | ✔️ | ✔️ | ✔️ |
| Custom App Allow List | - | ✔️ | ✔️ |
| Remove Ads | - | ✔️ | ✔️ |
| Focus trend analysis | - | ✔️ | ✔️ |
| Plant real trees* | - | ✔️ | ✔️ |
| Custom Focus Tags | - | ✔️ | ✔️ |
| Auto-start Next Session | - | ✔️ | ✔️ |
| 3x focus coin | - | - | ✔️ |
| Grow Plus Exclusive Trees | - | - | ✔️ |
| Try Seasonal New Trees First | - | - | ✔️ |
| Enjoy Seasonal Select Crystal Trees | - | - | ✔️ |
| [Time Guard] Block more interruptive apps | - | - | ✔️ |
| [Mindful Space] Enjoy various Soundscapes | - | - | ✔️ |

* *The maximum limit for planting real trees is 5.

- Pro users include iOS users who have paid to download Forest from the App Store, as well as Android users who have unlocked the Pro version. 
- For Pro users, all Pro features and benefits that were originally unlocked will be retained for life, regardless of purchasing Plus membership.

</div>`)
};

const pt_br_subscription_detail_page_content_cna = /** @type {(inputs: Subscription_Detail_Page_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<div>

# Plus Tree Collection

- Unlimited access to Plus Exclusive Trees, Seasonal New Trees, and Seasonal Select Crystal Trees during your Plus membership. (not permanently unlocked)
- Plus Exclusive Trees are strictly reserved for Plus members.
- Seasonal content updates every Dec 31, Mar 31, Jun 30, and Sep 30 (UTC+8), including Seasonal New Trees, and Seasonal Select Crystal Trees.
- All trees can be used in "Plant together."


</div>

<div>

# Plus Advanced Features

|  | Free | Pro | Plus |
| --- | --- | --- | --- |
| Focus Timer | ✔️ | ✔️ | ✔️ |
| Duration Statistics | ✔️ | ✔️ | ✔️ |
| Plant together  | ✔️ | ✔️ | ✔️ |
| Deep Focus Mode | ✔️ | ✔️ | ✔️ |
| Custom App Allow List | - | ✔️ | ✔️ |
| Remove Ads | - | ✔️ | ✔️ |
| Focus trend analysis | - | ✔️ | ✔️ |
| Plant real trees* | - | ✔️ | ✔️ |
| Custom Focus Tags | - | ✔️ | ✔️ |
| Auto-start Next Session | - | ✔️ | ✔️ |
| 3x focus coin | - | - | ✔️ |
| Grow Plus Exclusive Trees | - | - | ✔️ |
| Try Seasonal New Trees First | - | - | ✔️ |
| Enjoy Seasonal Select Crystal Trees | - | - | ✔️ |
| [Time Guard] Block more interruptive apps | - | - | ✔️ |
| [Mindful Space] Enjoy various Soundscapes | - | - | ✔️ |

* *The maximum limit for planting real trees is 5.

- Pro users include iOS users who have paid to download Forest from the App Store, as well as Android users who have unlocked the Pro version. 
- For Pro users, all Pro features and benefits that were originally unlocked will be retained for life, regardless of purchasing Plus membership.

</div>`)
};

const ru_subscription_detail_page_content_cna = /** @type {(inputs: Subscription_Detail_Page_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<div>

# Plus Tree Collection

- Unlimited access to Plus Exclusive Trees, Seasonal New Trees, and Seasonal Select Crystal Trees during your Plus membership. (not permanently unlocked)
- Plus Exclusive Trees are strictly reserved for Plus members.
- Seasonal content updates every Dec 31, Mar 31, Jun 30, and Sep 30 (UTC+8), including Seasonal New Trees, and Seasonal Select Crystal Trees.
- All trees can be used in "Plant together."


</div>

<div>

# Plus Advanced Features

|  | Free | Pro | Plus |
| --- | --- | --- | --- |
| Focus Timer | ✔️ | ✔️ | ✔️ |
| Duration Statistics | ✔️ | ✔️ | ✔️ |
| Plant together  | ✔️ | ✔️ | ✔️ |
| Deep Focus Mode | ✔️ | ✔️ | ✔️ |
| Custom App Allow List | - | ✔️ | ✔️ |
| Remove Ads | - | ✔️ | ✔️ |
| Focus trend analysis | - | ✔️ | ✔️ |
| Plant real trees* | - | ✔️ | ✔️ |
| Custom Focus Tags | - | ✔️ | ✔️ |
| Auto-start Next Session | - | ✔️ | ✔️ |
| 3x focus coin | - | - | ✔️ |
| Grow Plus Exclusive Trees | - | - | ✔️ |
| Try Seasonal New Trees First | - | - | ✔️ |
| Enjoy Seasonal Select Crystal Trees | - | - | ✔️ |
| [Time Guard] Block more interruptive apps | - | - | ✔️ |
| [Mindful Space] Enjoy various Soundscapes | - | - | ✔️ |

* *The maximum limit for planting real trees is 5.

- Pro users include iOS users who have paid to download Forest from the App Store, as well as Android users who have unlocked the Pro version. 
- For Pro users, all Pro features and benefits that were originally unlocked will be retained for life, regardless of purchasing Plus membership.

</div>`)
};

const th_subscription_detail_page_content_cna = /** @type {(inputs: Subscription_Detail_Page_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<div>

# Plus Tree Collection

- Unlimited access to Plus Exclusive Trees, Seasonal New Trees, and Seasonal Select Crystal Trees during your Plus membership. (not permanently unlocked)
- Plus Exclusive Trees are strictly reserved for Plus members.
- Seasonal content updates every Dec 31, Mar 31, Jun 30, and Sep 30 (UTC+8), including Seasonal New Trees, and Seasonal Select Crystal Trees.
- All trees can be used in "Plant together."


</div>

<div>

# Plus Advanced Features

|  | Free | Pro | Plus |
| --- | --- | --- | --- |
| Focus Timer | ✔️ | ✔️ | ✔️ |
| Duration Statistics | ✔️ | ✔️ | ✔️ |
| Plant together  | ✔️ | ✔️ | ✔️ |
| Deep Focus Mode | ✔️ | ✔️ | ✔️ |
| Custom App Allow List | - | ✔️ | ✔️ |
| Remove Ads | - | ✔️ | ✔️ |
| Focus trend analysis | - | ✔️ | ✔️ |
| Plant real trees* | - | ✔️ | ✔️ |
| Custom Focus Tags | - | ✔️ | ✔️ |
| Auto-start Next Session | - | ✔️ | ✔️ |
| 3x focus coin | - | - | ✔️ |
| Grow Plus Exclusive Trees | - | - | ✔️ |
| Try Seasonal New Trees First | - | - | ✔️ |
| Enjoy Seasonal Select Crystal Trees | - | - | ✔️ |
| [Time Guard] Block more interruptive apps | - | - | ✔️ |
| [Mindful Space] Enjoy various Soundscapes | - | - | ✔️ |

* *The maximum limit for planting real trees is 5.

- Pro users include iOS users who have paid to download Forest from the App Store, as well as Android users who have unlocked the Pro version. 
- For Pro users, all Pro features and benefits that were originally unlocked will be retained for life, regardless of purchasing Plus membership.

</div>`)
};

const tr_subscription_detail_page_content_cna = /** @type {(inputs: Subscription_Detail_Page_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<div>

# Plus Tree Collection

- Unlimited access to Plus Exclusive Trees, Seasonal New Trees, and Seasonal Select Crystal Trees during your Plus membership. (not permanently unlocked)
- Plus Exclusive Trees are strictly reserved for Plus members.
- Seasonal content updates every Dec 31, Mar 31, Jun 30, and Sep 30 (UTC+8), including Seasonal New Trees, and Seasonal Select Crystal Trees.
- All trees can be used in "Plant together."


</div>

<div>

# Plus Advanced Features

|  | Free | Pro | Plus |
| --- | --- | --- | --- |
| Focus Timer | ✔️ | ✔️ | ✔️ |
| Duration Statistics | ✔️ | ✔️ | ✔️ |
| Plant together  | ✔️ | ✔️ | ✔️ |
| Deep Focus Mode | ✔️ | ✔️ | ✔️ |
| Custom App Allow List | - | ✔️ | ✔️ |
| Remove Ads | - | ✔️ | ✔️ |
| Focus trend analysis | - | ✔️ | ✔️ |
| Plant real trees* | - | ✔️ | ✔️ |
| Custom Focus Tags | - | ✔️ | ✔️ |
| Auto-start Next Session | - | ✔️ | ✔️ |
| 3x focus coin | - | - | ✔️ |
| Grow Plus Exclusive Trees | - | - | ✔️ |
| Try Seasonal New Trees First | - | - | ✔️ |
| Enjoy Seasonal Select Crystal Trees | - | - | ✔️ |
| [Time Guard] Block more interruptive apps | - | - | ✔️ |
| [Mindful Space] Enjoy various Soundscapes | - | - | ✔️ |

* *The maximum limit for planting real trees is 5.

- Pro users include iOS users who have paid to download Forest from the App Store, as well as Android users who have unlocked the Pro version. 
- For Pro users, all Pro features and benefits that were originally unlocked will be retained for life, regardless of purchasing Plus membership.

</div>`)
};

const zh_cn_subscription_detail_page_content_cna = /** @type {(inputs: Subscription_Detail_Page_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<div>

# Plus 树种阵容

- Plus 会员期间，可无限使用「Plus 限定树」、「当季新树」以及「当季精选宝石树」（非永久解锁）
- Plus 限定树仅保留给 Plus 会员使用
- 季节内容会于每年 12月31日、3月31日、6月30日、9月30日 (UTC+8) 定期更新「当季新树」与「当季精选宝石树」。
- 所有树种皆可用于「多人一起种」模式

</div>

<div>

# Plus 进阶功能

|  | 免费版 | 专业版 | Plus 会员 |
| --- | --- | --- | --- |
| 专注计时 | ✔️ | ✔️ | ✔️ |
| 时长统计 | ✔️ | ✔️ | ✔️ |
| 与好友一起种 | ✔️ | ✔️ | ✔️ |
| 深度专注 | ✔️ | ✔️ | ✔️ |
| 自订软件白名单 | - | ✔️ | ✔️ |
| 无广告 | - | ✔️ | ✔️ |
| 专注趋势分析 | - | ✔️ | ✔️ |
| 为地球种下真树 | - | ✔️ | ✔️ |
| 自订专注标签 | - | ✔️ | ✔️ |
| 自动下一轮专注 | - | ✔️ | ✔️ |
| 专注金币 3 倍 | - | - | ✔️ |
| 独享 Plus 限定树种 | - | - | ✔️ |
| 抢先体验每季新树 | - | - | ✔️ |
| 无限使用当季精选宝石树 | - | - | ✔️ |
| [时间守护] 阻挡多个干扰 App | - | - | ✔️ |
| [正念空间] 享受更多声音场景 | - | - | ✔️ |

* *种真树目前上限为 5 棵。


- 专业版用户包含 iOS 有在 App Store 付费下载过 Forest 或是 Android 有解锁专业版的用户
- 专业版用户原先解锁专业版的功能和权益都将终身保留，无论是否有购买 Plus 会员

</div>`)
};

const zh_tw_subscription_detail_page_content_cna = /** @type {(inputs: Subscription_Detail_Page_Content_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<div>

# Plus 树种阵容

- Plus 会员期间，可无限使用「Plus 限定树」、「当季新树」以及「当季精选宝石树」（非永久解锁）
- Plus 限定树仅保留给 Plus 会员使用
- 季节内容会于每年 12月31日、3月31日、6月30日、9月30日 (UTC+8) 定期更新「当季新树」与「当季精选宝石树」。
- 所有树种皆可用于「多人一起种」模式

</div>

<div>

# Plus 进阶功能

|  | 免费版 | 专业版 | Plus 会员 |
| --- | --- | --- | --- |
| 专注计时 | ✔️ | ✔️ | ✔️ |
| 时长统计 | ✔️ | ✔️ | ✔️ |
| 与好友一起种 | ✔️ | ✔️ | ✔️ |
| 深度专注 | ✔️ | ✔️ | ✔️ |
| 自订软件白名单 | - | ✔️ | ✔️ |
| 无广告 | - | ✔️ | ✔️ |
| 专注趋势分析 | - | ✔️ | ✔️ |
| 为地球种下真树* | - | ✔️ | ✔️ |
| 自订专注标签 | - | ✔️ | ✔️ |
| 自动下一轮专注 | - | ✔️ | ✔️ |
| 专注金币 3 倍 | - | - | ✔️ |
| 独享 Plus 限定树种 | - | - | ✔️ |
| 抢先体验每季新树 | - | - | ✔️ |
| 无限使用当季精选宝石树 | - | - | ✔️ |
| [时间守护] 阻挡多个干扰 App | - | - | ✔️ |
| [正念空间] 享受更多声音场景 | - | - | ✔️ |

* *种真树目前上限为 5 棵。


- 专业版用户包含 iOS 有在 App Store 付费下载过 Forest 或是 Android 有解锁专业版的用户
- 专业版用户原先解锁专业版的功能和权益都将终身保留，无论是否有购买 Plus 会员

</div>`)
};

/**
* | output |
* | --- |
* | "<div> # Plus Tree Collection - Unlimited access to Plus Exclusive Trees, Seasonal New Trees, and Seasonal Select Crystal Trees during your Plus membership. (..." |
*
* @param {Subscription_Detail_Page_Content_CnaInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_detail_page_content_cna = /** @type {((inputs?: Subscription_Detail_Page_Content_CnaInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Detail_Page_Content_CnaInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_detail_page_content_cna(inputs)
	if (locale === "ar") return ar_subscription_detail_page_content_cna(inputs)
	if (locale === "de") return de_subscription_detail_page_content_cna(inputs)
	if (locale === "es") return es_subscription_detail_page_content_cna(inputs)
	if (locale === "fr") return fr_subscription_detail_page_content_cna(inputs)
	if (locale === "it") return it_subscription_detail_page_content_cna(inputs)
	if (locale === "ja") return ja_subscription_detail_page_content_cna(inputs)
	if (locale === "ko") return ko_subscription_detail_page_content_cna(inputs)
	if (locale === "pt_br") return pt_br_subscription_detail_page_content_cna(inputs)
	if (locale === "ru") return ru_subscription_detail_page_content_cna(inputs)
	if (locale === "th") return th_subscription_detail_page_content_cna(inputs)
	if (locale === "tr") return tr_subscription_detail_page_content_cna(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_detail_page_content_cna(inputs)
	return zh_tw_subscription_detail_page_content_cna(inputs)
});